import { render, staticRenderFns } from "./medical_list.vue?vue&type=template&id=e88d128a"
import script from "./medical_list.vue?vue&type=script&lang=js"
export * from "./medical_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports